import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { PARKING_TYPES_MAP_VALUE_TO_LABEL } from './constants';
import { EParkingType } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'parkingType' as const;

export const parkingTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const parkingTypes = getTermsValue('parking_type')(jsonQuery);

    if (parkingTypes === null || parkingTypes.includes(EParkingType.Rooftop)) {
      return null;
    }

    return parkingTypes.map(parkingType => ({
      label: `${PARKING_TYPES_MAP_VALUE_TO_LABEL[parkingType]} парковка`,
      value: createTagValue(ID, parkingType.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => {
    const parkingTypes = getTermsValue('parking_type')(jsonQuery);

    if (parkingTypes === null) {
      return jsonQuery;
    }

    const newParkingTypes = parkingTypes.filter(parkingType => parkingType !== EParkingType.Rooftop);

    return newParkingTypes.length
      ? setTerms('parking_type')(jsonQuery)(newParkingTypes)
      : resetTerms(['parking_type'])(jsonQuery);
  },
};
